import fluent, { FluentIterable } from "fluent-iterable";
import { DataProvider, DataProviderArgs } from "./DataProvider";
import { ChangeSet } from "./ChangeSet";

export class NoOpDataProvider extends DataProvider {
    constructor(args: DataProviderArgs) {
        super(args, []);
    }
    public override async create(_props: any, ..._args: any[]): Promise<any> {
        return new Promise(() => false);
    }

    public override async read(_id: string, ..._args: any[]): Promise<any> {
        return undefined;
    }
    public override async update(_props: any, ..._args: any[]): Promise<any> {
        return new Promise(() => {});
    }
    public override async delete(_id: string, ..._args: any[]): Promise<void> {
        return new Promise(() => {});
    }

    public override async all(): Promise<FluentIterable<any>> {
        return fluent([]);
    }

    public override onChangeSet(_source: DataProvider, _changeSet: ChangeSet<any>): void {
        // no-op
    }
}
